<navigation
  [listClass]="'side-nav'"
  [itemClass]="'side-nav-item'"
  [linkClass]="'side-nav-link'"
  [ddLinkClass]="'side-nav-dropdown'"
  [ddMenuClass]="'sub-nav'"
  data-cy="side-navigation"
>
</navigation>
